import * as R from 'ramda';
export function toggleArrayItem(_arr, _item) {
    return R.curry((arr, item) => R.symmetricDifference(arr, [item]))(...arguments);
}
